import { useContext, useMemo } from 'react';
import { Player, PlayerGameStatus } from '../API';
import { PlayerSessionContext } from '../contexts/PlayerSessionContext';

export function useSessionControls() {
  return useContext(PlayerSessionContext);
}

export function useState() {
  return useContext(PlayerSessionContext).state;
}

export function useSession() {
  return useContext(PlayerSessionContext).session;
}

export function useRound() {
  return useContext(PlayerSessionContext).currentRound;
}

export function usePlayer() {
  return useContext(PlayerSessionContext).player;
}

export function useSharingPlayer() {
  const { players } = useContext(PlayerSessionContext);

  return useMemo(() => {
    const sharingPlayer = players.find((player) => {
      if (player === null) return false;
      return player.gameStatus === PlayerGameStatus.SHARING;
    }) as Player;

    if (!sharingPlayer) {
      return null;
    }

    return sharingPlayer;
  }, [players]);
}

export function useSharedPlayers() {
  const { players } = useContext(PlayerSessionContext);

  return useMemo(() => {
    return players.filter((player) => {
      if (player === null) return false;
      return player.gameStatus === PlayerGameStatus.SHARING;
    });
  }, [players]);
}

export function usePlayers() {
  return useContext(PlayerSessionContext).players;
}

export function useSetupPlayer() {
  return useContext(PlayerSessionContext).setupPlayer;
}

export function useRoundArtwork() {
  return useContext(PlayerSessionContext).artwork;
}

export function useSubmitDrawing() {
  return useContext(PlayerSessionContext).submitDrawing;
}

export function useReactions() {
  return useContext(PlayerSessionContext).reactions;
}

export function useUpdateSentiment() {
  return useContext(PlayerSessionContext).updatePlayerSentiment;
}

export function useUpdatePlayerQuestion() {
  return useContext(PlayerSessionContext).updatePlayerQuestion;
}

export function useReactToArtwork() {
  return useContext(PlayerSessionContext).reactToArtwork;
}

export function useGetArtworkReactions() {
  return useContext(PlayerSessionContext).getArtworkReactions;
}
